import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerComponent } from '../../layout/container/container.component';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-hero-banner',
  standalone: true,
  imports: [CommonModule, ContainerComponent],
  templateUrl: './hero-banner.component.html',
  styleUrl: './hero-banner.component.scss'
})
export class HeroBannerComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('heroBanner', { static: false }) heroBanner?: ElementRef;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    // No necesita tracking de página aquí, se maneja en la página padre
  }

  ngAfterViewInit() {
    // Registrar la sección para tracking de analytics
    if (this.heroBanner?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.heroBanner.nativeElement,
        'About Hero Banner',
        'about-hero-banner-section'
      );
    }
  }

  ngOnDestroy() {
    // Cleanup si es necesario
  }
}
